import React from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import "./SliderWrapper.css"

export default function SliderWrapper({ children, settings, sliderRef }) {
  const defaultSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  const activeSettings = settings ? settings : defaultSettings
  return (
    <Slider ref={sliderRef} {...activeSettings}>
      {children}
    </Slider>
  )
}
